import { Injectable } from '@angular/core';
import { Api } from 'app/core/api/api';
import { ApiService } from 'app/core/services/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(
       private _apiService: ApiService,
       private _api: Api,
   ) { }
 
     /**
      * for getting list
      * @param data
      */
     list(data: any, isPartner?: any){
         return this._apiService.post(this._api.API.INVENTORY.INVENTORY_LIST,data);
     }
}
